// React
import React from 'react';
// External libs
import classNames from 'classnames';
import GoogleMapReact from 'google-map-react';
// Tools
import { useFormatMessage } from '../../intl/intl';
// Styles
import useStyles from './RTMap.styles';
import Conditional from './../common/conditional/Conditional';
import RestaurantIcon from '../icons/restaurant-icon/RestaurantIcon';
import CustomMarker from './../common/custom-marker/CustomMarker';
import RTIcon from './../icons/rt-icon/RTIcon';
import CustomButton from './../common/buttons/custom-button';

const RTMap = ({
  center,
  classes,
  RT,
  store,
  zoom,
  orderId,
  openDialogReleaseRT,
  showReleaseRT,
}) => {
  const componentClasses = useStyles();
  const releaseRTButtonText = useFormatMessage({
    id: 'rtReleaseButton.text',
  });
  if (store.store_id) {
    center.lat = store.lat;
    center.lng = store.lng;
  }

  return (
    <Conditional if={store.store_id}>
      <div className={classNames(componentClasses.root, classes.root)}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_API_KEY }}
          defaultCenter={center}
          defaultZoom={zoom}
        >
          <CustomMarker
            className={componentClasses.restaurantImgContainer}
            lat={center.lat}
            lng={center.lng}
          >
            <RestaurantIcon className={componentClasses.restaurantImg} />
          </CustomMarker>
          {RT.id && RT.lat && RT.lng && (
            <CustomMarker
              className={componentClasses.RTImgContainer}
              lat={RT.lat}
              lng={RT.lng}
            >
              <RTIcon direction={RT.bearing} />
            </CustomMarker>
          )}
        </GoogleMapReact>
        <Conditional if={showReleaseRT}>
          <CustomButton
            lat={center.lat}
            lng={center.lng}
            classes={{ root: componentClasses.releaseRtButton }}
            color='primary'
            disabled={false}
            onClick={() => {
              openDialogReleaseRT(orderId);
            }}
            text={releaseRTButtonText}
            variant='contained'
          />
        </Conditional>
      </div>
    </Conditional>
  );
};

RTMap.defaultProps = {
  center: {
    lat: 4.678695,
    lng: -74.055456,
  },
  classes: {},
  showReleaseRT: false,
  zoom: 15,
};

export default RTMap;
